import { FastlyImage } from '@components/common/image'
import Link from 'next/link'

const IMAGE_PATH = '/images/courses/ads-banner/'
type Props = {
  title?: string
  imagePath?: string
  mobileImagerPath?: string
  url?: string
}
const FooterBanner = ({ title, imagePath, mobileImagerPath, url }: Props) => {
  return (
    <div className="my-16 text-center">
      <Link
        href={`${url ? url : 'https://www.codingal.com/register/'}`}
        prefetch={false}
      >
        <a className="mx-auto relative inline-block">
          <div className="hidden lg:block">
            {!imagePath && (
              <FastlyImage
                src={`${IMAGE_PATH}scratch-programming.png`}
                webpSrc={`${IMAGE_PATH}scratch-programming.webp`}
                height={251}
                width={943}
                alt="scratch coding"
              />
            )}
            {imagePath && (
              <FastlyImage
                src={`${imagePath}.png`}
                webpSrc={`${imagePath}.webp`}
                height={251}
                width={943}
                alt={title}
              />
            )}
          </div>
          <div className="lg:hidden">
            {!mobileImagerPath && (
              <FastlyImage
                src={`${IMAGE_PATH}scratch-programming-mobile.png`}
                webpSrc={`${IMAGE_PATH}scratch-programming-mobile.webp`}
                height={620}
                width={347}
                alt={title}
              />
            )}
            {mobileImagerPath && (
              <FastlyImage
                src={`${mobileImagerPath}.png`}
                webpSrc={`${mobileImagerPath}.webp`}
                height={620}
                width={347}
                alt={title}
              />
            )}
          </div>
          <div className="absolute top-5 lg:max-w-3/5 px-8 text-center lg:text-left">
            <p className="text-2xl font-700 text-white leading-tight">
              {title}
            </p>
            <button className="btn bg-white outline-none border-none text-orange mt-4 py-3">
              Try a free lesson
            </button>
          </div>
        </a>
      </Link>
    </div>
  )
}

export default FooterBanner
